var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59469 0.669983C9.9884 0.287132 10.6055 0.257062 11.0346 0.599819C11.547 1.0092 11.5844 1.77524 11.1141 2.23251L3.12627 10L11.1141 17.7675C11.5844 18.2248 11.547 18.9908 11.0346 19.4002C10.6055 19.7429 9.98841 19.7129 9.59469 19.33L1.74846e-06 10L9.59469 0.669983Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImage);
export default __webpack_public_path__ + "static/media/arrow_image.b909b247.svg";
export { ForwardRef as ReactComponent };